import React, { Component } from 'react'
import { Button, Form, Input, InputNumber, Space } from 'antd'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'

type QuestionAnswersProps = {
  formRef: any
}

export default class QuestionAnswers extends Component<QuestionAnswersProps> {
  render() {
    const { formRef } = this.props

    return (
      <Form.List name="answers">
        {(fields, { add, remove }) => {
          const addDefaultValues = {
            uuid: null,
            value: '',
            position: fields.length
          }

          if (fields.length === 0) {
            setTimeout(() => {
              add(addDefaultValues)
            }, 500)
          }

          return (
            <>
              {
                fields.map(field => {
                  const readOnly = formRef.getFieldValue(['answers', field.name, 'uuid']) ? true : false

                  return (
                    <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="start">
                      <Form.Item
                        {...field}
                        name={[field.name, 'value']}
                        fieldKey={[field.fieldKey, 'value']}
                        rules={[
                          {
                            required: true,
                            message: 'Missing answer text'
                          }
                        ]}
                      >
                        <Input.TextArea disabled={readOnly} placeholder="Answer" rows={3} cols={50} />
                      </Form.Item>
                      <Form.Item
                        {...field}
                        name={[field.name, 'position']}
                        fieldKey={[field.fieldKey, 'position']}
                        rules={[
                          {
                            required: true,
                            message: 'Missing position'
                          }
                        ]}
                      >
                        <InputNumber placeholder="Position" min={0} max={100} />
                      </Form.Item>

                      {
                        fields.length > 1 ? <MinusCircleOutlined onClick={() => remove(field.name)} /> : null
                      }
                    </Space>
                  )
                })
              }

              <Form.Item>
                <Button type="dashed" block onClick={() => add(addDefaultValues)}>
                  <PlusCircleOutlined /> Add more answers
                </Button>
              </Form.Item>
            </>
          )
        }}
      </Form.List>
    )
  }
}
